// Pages - lazy loaded
const Intro = () => import(/* webpackChunkName: "js/intro" */ './pages/static/intro.vue')
const Home = () => import(/* webpackChunkName: "js/home" */ './pages/home.vue')
const Story = () => import(/* webpackChunkName: "js/story" */ './pages/story.vue')
const Stories = () => import(/* webpackChunkName: "js/stories" */ './pages/stories.vue')
const Featured = () => import(/* webpackChunkName: "js/featured" */ './pages/featured.vue')
const Discounted = () => import(/* webpackChunkName: "js/discounted" */ './pages/discounted.vue')
const Product = () => import(/* webpackChunkName: "js/product" */ './pages/product.vue')
const Checkout = () => import(/* webpackChunkName: "js/checkout" */ './pages/checkout/main.vue')
const CheckoutReminder = () => import(/* webpackChunkName: "js/checkout_reminder" */ './pages/static/checkout_reminder.vue')
const Listing = () => import(/* webpackChunkName: "js/listing" */ './pages/listing.vue')
const Campaigns = () => import(/* webpackChunkName: "js/campaigns" */ './pages/campaigns.vue')
const Campaign = () => import(/* webpackChunkName: "js/campaign" */ './pages/campaign.vue')
const SearchResults = () => import(/* webpackChunkName: "js/search_results" */ './pages/search_results.vue')
const Error = () => import(/* webpackChunkName: "js/error" */ './pages/error.vue')

export default {
    mode: 'history',
    routes: [
        {
            path: '/intro',
            name: 'intro',
            meta: {pageType: 'page'},
            component: Intro
        },
        {
            path: '/',
            name: 'home',
            meta: {pageType: 'page'},
            component: Home
        },
        {
            path: '/story',
            name: 'story',
            meta: {pageType: 'page'},
            component: Story
        },
        {
            path: '/stories',
            name: 'stories',
            meta: {pageType: 'page'},
            component: Stories
        },
        {
            path: '/featured',
            name: 'featured',
            meta: {pageType: 'page'},
            component: Featured
        },
        {
            path: '/discounted',
            name: 'discounted',
            meta: {pageType: 'page'},
            component: Discounted
        },
        {
            path: '/product',
            name: 'product',
            meta: {pageType: 'page'},
            component: Product
        },
        {
            path: '/checkout',
            name: 'checkout',
            meta: {pageType: 'page'},
            component: Checkout
        },
        {
            path: '/checkout-reminder',
            name: 'checkout_reminder',
            meta: {pageType: 'page'},
            component: CheckoutReminder
        },
        {
            path: '/listing',
            name: 'listing',
            meta: {pageType: 'page'},
            component: Listing
        },
        {
            path: '/campaigns',
            name: 'campaigns',
            meta: {pageType: 'page'},
            component: Campaigns
        },
        {
            path: '/campaign',
            name: 'campaign',
            meta: {pageType: 'page'},
            component: Campaign
        },
        {
            path: '/search-results',
            name: 'search_results',
            meta: {pageType: 'page'},
            component: SearchResults
        },
        {
            path: '/error',
            name: 'error',
            meta: {pageType: 'page'},
            component: Error
        },
        {
            path: '*',
            name: 'error_404',
            meta: {pageType: 'page', code: 404},
            component: Error
        },
        // do not add routes below this line
    ],
    // return to top
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
}
